import { InfoIcon } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

import type { IconProps } from '@/_components';
import { Icon, Text } from '@/_components';

import { CardContainer } from './layout';

type NoSectionMessageProps = {
  message?: string;
  icon?: IconProps['icon'];
  isMain?: boolean;
};

export function NoSectionMessage({ message = 'No Data', icon = InfoIcon, isMain = false }: NoSectionMessageProps) {
  return (
    <CardContainer className={twMerge('mx-auto w-full', isMain ? 'lg:max-w-[calc(100%-18.5rem)]' : '')}>
      <Icon icon={icon} className="text-c-card-muted m-auto size-6" />
      <Text as="h6" className="text-c-card-muted mt-2 text-center font-medium">
        {message}
      </Text>
    </CardContainer>
  );
}
